import { DoubleArrowRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useMobileApp } from '../../../../hooks/useMobileApp';
import { VideoComponentInterface } from '../../../../interfaces/pagebuilder';
import { createDisplayLink } from '../../../../services/helper';

interface VideoTemplateProps {
  videoSettings?: VideoComponentInterface['videoSettings'];
}

const VideoTemplate = ({ videoSettings }: VideoTemplateProps) => {
  const reactPlayerRef = useRef(null);
  const [position, setPosition] = useState(0);
  const [videoFiles, setVideoFiles] = useState(videoSettings?.videoFiles || []);
  const { isAppView } = useMobileApp();

  useEffect(() => {
    if (videoSettings?.videoFiles && videoSettings?.videoFiles?.length > 0) setVideoFiles(videoSettings?.videoFiles);
  }, [videoSettings?.videoFiles]);

  const getVideoUrl = () => {
    if (videoFiles[position]?.muxId && videoFiles[position]?.playback_ids?.[0]) {
      return videoFiles?.[position].path ?? `https://stream.mux.com/${videoFiles[position]?.playback_ids?.[0]?.id}.m3u8`;
    }
    return createDisplayLink(videoFiles[position]?.file, undefined, undefined, undefined, undefined, false);
  };

  return (
    <div className="grid relative place-items-center w-full h-full">
      <div className="w-full h-full aspect-video">
        {videoFiles[position]?.filetype.includes('video') && getVideoUrl() ? (
          <ReactPlayer
            playsinline={isAppView()}
            className="bg-black"
            light={videoSettings?.thumbnail && !videoSettings?.autoplay ? createDisplayLink(videoSettings?.thumbnail) : undefined}
            width="100%"
            height="100%"
            ref={reactPlayerRef}
            playing={videoSettings?.autoplay === true}
            muted={videoSettings?.muted === true}
            onEnded={() => videoFiles.length > position + 1 && setPosition(position + 1)}
            controls
            url={getVideoUrl()}
          />
        ) : (
          <img src={createDisplayLink(videoFiles[position]?.file)} className="w-auto h-full" />
        )}
      </div>
      {position > 0 && (
        <div className="grid absolute top-0 bottom-0 left-0 place-items-center">
          <IconButton onClick={() => setPosition((prevpos) => prevpos - 1)} className="outline-none bg-white opacity-50 transform scale-x-[-1]" size="small">
            <DoubleArrowRounded />
          </IconButton>
        </div>
      )}
      {position < videoFiles.length - 1 && (
        <div className="grid absolute top-0 right-0 bottom-0 place-items-center">
          <IconButton onClick={() => setPosition((prevpos) => prevpos + 1)} className="bg-white opacity-50 outline-none" size="small">
            <DoubleArrowRounded />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default VideoTemplate;
